<template>
    <div>
        <el-row>
            <el-table :data="attendantsData.list" style="width: 100%" height="400"
                :header-cell-style="{background:'#F0F0F0',color:'#000000'}">
                <el-table-column align="center" label="序号" width="50">
                    <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                </el-table-column>
                <el-table-column prop="company_name" label="分公司" align="center"></el-table-column>
                <el-table-column prop="modular_name" label="板块" align="center"></el-table-column>
                <el-table-column prop="city_id" label="城市" align="center"></el-table-column>
                <el-table-column prop="project_name" label="项目" align="center"></el-table-column>
                <el-table-column prop="post_name" label="岗位" align="center"></el-table-column>
                <el-table-column prop="staff_name" label="姓名" align="center"></el-table-column>
            </el-table>
        </el-row>
        <el-row style="margin-top: 10px; text-align: center;">
            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                layout=" prev, pager, next, jumper" :total="attendantsData.total">
            </el-pagination>
        </el-row>
    </div>
</template>

<script>
    export default {
        props:["attendantsData", "idString"],
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                staff_ids: "",
            };
        },
        methods: {
            handleCurrentChange(e) {
                this.page_num = e;
                this.$parent.$parent.StaffFind(this.idString, this.page_num, this.page_size);
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// KqzGl_StaffFind.vue?46d27cf3